import ReportMTBF from '@/models/ReportMTBF/ReportMTBF';

export default class ReportMTBFFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.filterPeriodDateFrom = '';
		this.filterPeriodDateTo = '';
		this.filterMachineCode = '';
		this.tempId = '';
		this.startProductionFrom = '';
		this.startProductionTo = '';
		this.code = '';
		this.totalWaktuMesinBeroperasi = '';
		this.totalFrekuensiTroubleMesin = '';
		this.mttr = '';
		this.mtbf = '';
		this.totalWaktuMesinTrouble = '';
		this.availability = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			filterPeriodDateFrom : '0',
			filterPeriodDateTo : '0',
			filterMachineCode : '0',
			tempId : '0',
			startProductionFrom : '0',
			startProductionTo : '0',
			code : '0',
			totalWaktuMesinBeroperasi : '0',
			totalFrekuensiTroubleMesin : '0',
			mttr : '0',
			mtbf : '0',
			totalWaktuMesinTrouble : '0',
			availability : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}